/* eslint-disable no-console */
/* eslint-disable react/no-unstable-nested-components */
import { 
  Breadcrumbs,
  Button,
  Content,
  Dialog,
  Flex,
  Pane,
  Table,
  Text,
  Toast,
} from '@leverege/ui-elements'
// eslint-disable-next-line no-unused-vars
import React, { useCallback, useEffect, useState } from 'react'
import { GlobalState } from '@leverege/ui-redux'
import moment from 'moment'
import Molten from '@leverege/molten'
import { TitleBar, Toolbar } from '@leverege/ui-plugin'

const formatFileName = ( original ) => {
  const slashInd = original.path.lastIndexOf( '/' )
  return slashInd > -1 ? original.path.substring( slashInd + 1 ) : original.path
}

const handleDownload = async ( original ) => {
  fetch( original.data.url )
    .then( ( response ) => {
      const text = response.text()
      const blob = new Blob( [ text ], { type : 'text/plain' } )
      const url = window.URL.createObjectURL( blob )
      const link = document.createElement( 'a' )
      link.href = url
      link.setAttribute( 'download', formatFileName( original ) )
      document.body.appendChild( link )
      link.click()
      URL.revokeObjectURL( url )
    } )
    .catch( error => console.error( 'Error downloading file:', error ) )
}

function BoatDebugLogsScreen( props ) {

  const { parentItem } = props
  const networkName = parentItem?.data?.networkId || null
  const esn = parentItem?.data?.networkAliases?.[networkName]?.esn
  const name = esn || parentItem.data.name
  const resourcePath = `debuglog/${esn}`

  const [ loading, setLoading ] = useState( false )
  const [ data, setData ] = useState( [] )
  const [ showModal, setShowModal ] = useState( false )
  const [ selectedData, setSelectedData ] = useState( null )
  const [ pageIndex, setPageIndex ] = useState( 0 )
  const [ pageSize, setPageSize ] = useState( 50 )
  const [ pages, setPages ] = useState( null )

  const onClickBreadcrumb = ( ctx ) => {
    const isRoot = ctx.data?.root
    GlobalState.dispatch( isRoot ? push( rootPath ) : push( overViewPath ) )
  }

  const handleOpenModal = ( rowData ) => {
    setSelectedData( rowData )
    setShowModal( true )
  }

  const handleCloseModal = () => {
    setShowModal( false )
  }

  function TextViewer( { showModal, onClose, original } ) {
    const [ data, setData ] = useState( [] )
    const [ loading, setLoading ] = useState( true )
    
    const fetchData = useCallback( async () => {
      setLoading( true )
      try {
        const response = await fetch( original.data.url )
        const formattedData = await response.text()
        setData( formattedData )
      } catch ( error ) {
        // eslint-disable-next-line no-console
        console.error( 'Failed to load data:', error )
      } finally {
        setLoading( false )
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ original ] )

    useEffect( () => {
      if ( showModal ) {
        fetchData()
      }
    }, [ fetchData, showModal ] )

    return (
      <Dialog onClose={onClose} closeOnDocumentClick closeOnEscape show={showModal}>
        <Content.Header>
          <TitleBar
            variant="screenTitle"
            title={formatFileName( original )}/>
        </Content.Header>
        <Content.Area>
          <Flex style={{ width : 1400, height : 800 }}>
            <Text
              loading={loading}
              loadingText={<Flex className="defaultFlex" justify="center"><i className="fa fa-spinner fa-spin fa-2x fa-fw" /></Flex>}/>
            <pre>{data}</pre>
          </Flex>
        </Content.Area>
      </Dialog>
    )
  }

  const columns = [
    {
      Header : 'Date',
      Cell : ( { original } ) => `${moment( original.createdAt ).format( 'MM/DD/YYYY HH:mm' )}`, 
    },
    {
      Header : 'Filename',
      Cell : ( { original } ) => formatFileName( original ), 
    },
    {
      Header : 'Action',
      Cell : ( { original } ) => (
        <Flex direction="row">
          <Button 
            style={{ margin : 5 }} 
            variant="primary" 
            icon="fa fa-download" 
            onClick={() => handleDownload( original )}/>
          <Button
            style={{ margin : 5 }}
            variant="primary"
            icon="fa fa-eye"
            onClick={() => handleOpenModal( original )} />
        </Flex>
      )
    }
  ]

  const listResources = async ( pageIndex, pageSize ) => {
    try {
      const systemId = Molten.getConfig( 'api/systemId' )
      setLoading( true )

      const { items, total } = await GlobalState.dispatch( async ( dispatch, getState, { api } ) => {
        return api.system( systemId )
          .resources()
          .list( resourcePath, { limit : pageSize, offset : pageIndex * pageSize, order : [ [ 'createdAt', 'desc' ] ] } )
      } )

      setData( items )
      setPages( Math.ceil( total / pageSize ) )
    } catch ( error ) {
      console.error( 'Error fetching debug logs', error )
      Toast.error( 'Error fetching debug logs' )
    } finally {
      setLoading( false )
    }
  }

  const handlePageSizeChange = ( newPageSize, newPage ) => {
    setPageSize( newPageSize )
    setPageIndex( newPage )
  }

  const handlePageChange = ( page ) => {
    setPageIndex( page )
  }

  useEffect( () => {
    listResources( pageIndex, pageSize )
  }, [ pageIndex, pageSize ] )

  return (
    <Content>
      <Pane variant="topNavBreadcrumbs">
        <Breadcrumbs 
          variant="topNavBreadcrumbs"
          onClick={onClickBreadcrumb}
          crumbs={[ 
            { name : process.env.BOAT_BREADCRUMB_NAME || 'Siren Devices', root : true },
            { name, device : true },
            { name : 'Debug Logs' }
          ]}/>
      </Pane>
      <Content.Header>
        <TitleBar
          variant="screenTitle"
          title="Debug Logs"
          icon="fa-solid fa-file">
          <Toolbar
            variant="actionBar"
            prefer="icon"
            matchContext={{}}
            context={props} />
        </TitleBar>
      </Content.Header>
      <Content.Area>
        <Flex variant="colM">
          <Table
            data={data}
            columns={columns}
            loading={loading}
            loadingText={(
              <Flex className="defaultFlex" justify="center">
                <i className="fa fa-spinner fa-spin fa-2x fa-fw" />
              </Flex>
            )}
            defaultPageSize={20}
            pages={pages}
            onPageSizeChange={handlePageSizeChange}
            page={pageIndex}
            pageSizeOptions={[ 20, 50, 100, 200 ]}
            manual
            showPagination
            showPaginationBottom
            onPageChange={handlePageChange}/>
        </Flex>
      </Content.Area>
      {showModal && selectedData && (
        <TextViewer
          showModal={showModal}
          original={selectedData}
          onClose={handleCloseModal} />
      )}
    </Content>
  )

}

export default BoatDebugLogsScreen
